﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260125
    Description: Functions to work with fetch api
*/


const isValidLink = async (url) => {

    // Taken from AI response on google 
    try {
        const response = await fetch(url, {
            method: 'HEAD' // Using the HEAD method is efficient as it only fetches headers, not the entire body.
        });
        // Check if the response status is successful (e.g., 200-299)
        return response.ok; // 'ok' is true for status codes in the 200-299 range.
    } catch (error) {
        // This catches network errors or CORS issues, suggesting the URL might not be accessible.
        return false;
    }
}


export { isValidLink };